import { ValidationErrors } from 'final-form';
import React, { ReactNode } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useCreateEditEventFlowStore } from '~admin/store/create-edit-event-flow-store-provider';
import { getMarketplaceInitialValues } from '~admin/view/components/create-event/helper/create-event-initial-values.helper';
import { marketplaceValidators } from '~admin/view/components/create-event/helper/create-event-validators.helper';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import {
  MarketplaceDetailsFields,
  MarketplaceFormData,
} from '~admin/view/components/details/marketplace-details/marketplace-details-fields.component';
import { WizardPageProps } from '~admin/view/components/ui/form/wizard.component';
import { Box } from '~common/components/box.component';
import { Button } from '~common/components/button/button.component';
import { Column } from '~common/components/column.component';
import { Span } from '~common/components/span.component';
import { Color } from '~common/model/basics';
import { PlusIcon } from '~web/view/components/ui/icon/plus.icon';

export const MarketplaceDetails: React.FunctionComponent<WizardPageProps<EventFormData>> = ({
  formRenderProps,
}) => {
  const { t } = useTranslation();
  const { eventDates } = useCreateEditEventFlowStore();
  const { eventDateTimeEnd } = eventDates;

  return (
    <Container>
      <FieldGroupTitle>{t('createEvent.marketplaceDetails.title')}</FieldGroupTitle>
      <FieldArray
        name={'marketplaces'}
        validate={(values: MarketplaceFormData[]): ValidationErrors[] =>
          marketplaceValidators(values, eventDateTimeEnd)
        }
      >
        {({ fields }): ReactNode => {
          const onRemove = (index: number): void => {
            fields.remove(index);
          };

          const onAdd = (): void => {
            fields.push(getMarketplaceInitialValues());
          };

          return (
            <>
              {fields.map((name: string, index: number) => (
                <MarketplaceDetailsFields
                  key={name}
                  name={name}
                  marketplaceIndex={index}
                  onRemove={onRemove}
                  form={formRenderProps.form}
                />
              ))}
              <Box>
                <Button color={Color.White} onClick={onAdd}>
                  <StyledPlusIcon color={Color.Black} width={16} height={16} />
                  {t('createEvent.marketplaceDetails.addMarketplace')}
                </Button>
              </Box>
            </>
          );
        }}
      </FieldArray>
    </Container>
  );
};

const Container = styled(Column)`
  width: 100%;
`;

const FieldGroupTitle = styled(Span)`
  font-weight: bold;
  font-size: 22px;
  line-height: 22px;
  margin: 18px 0 12px;
`;

const StyledPlusIcon = styled(PlusIcon)`
  fill: currentColor;
  margin-right: 12px;
`;



// WEBPACK FOOTER //
// ./view/components/details/marketplace-details/marketplace-details.component.tsx